
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";
import { ShiftDeleteFormDataDto, ShiftDeleteFormDto } from "@/types/shift.type";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import ShiftMixin from "../shift.mixin";
import { Shift } from "../shift.types";

@Component({
  computed: {
    ...mapState("Shift", { formData: "deleteFormData", form: "deleteForm" })
  }
})
export default class ShiftDeleteModal extends Mixins(ValidatedFormMixin, ShiftMixin) {
  @Prop() shift!: Shift;

  formData!: ShiftDeleteFormDataDto;
  form!: ShiftDeleteFormDto;

  mounted(): void {
    this.$store.commit("Shift/updateField", {
      path: "deleteForm",
      value: new ShiftDeleteFormDto()
    });
  }

  closeModal(): void {
    this.$bvModal.hide("shift-delete-modal");
  }

  async onDelete(): Promise<void> {
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.setLoading(true);

        this.form.id = this.shift.id;
        await this.$store.dispatch("Shift/deleteShift");

        this.setLoading(false);
        
        this.$emit("delete");
        this.closeModal();
      }
    });
  }

  onCancel(): void {
    this.closeModal();
  }
}
